import firebase from "firebase/app";

import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import resolveTodo from "astrid-firestore/src/api/todos/utils/resolveTodo";
import updateDocument from "astrid-firestore/src/helpers/updateDocument";

import { useProfile } from "../../../../authentication/state/profile";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

export default function TodoDropdownMenu({ todo, managerOptions }) {
	const { t } = useTranslation();

	const user = useProfile();

	return (
		<DropdownMenu
			iconStyle={{ display: "flex", alignItems: "center", justifyContent: "center", height: 50, width: 30 }}
			menuStyle={{ top: 30 }}
			maxHeight="37vh"
		>
			{({ setLoading }) => (
				<>
					<Dropdown.Item
						text={t("markAsResolved", "Mark as resolved")}
						onClick={async (e) => {
							e.preventDefault();
							setLoading(true);
							await resolveTodo(firebase, { todo, user });
							setLoading(false);
						}}
					/>

					{managerOptions?.length > 0 && (
						<>
							<Dropdown.Divider />

							<Dropdown.Header content={t("assign", "Assign")} />
						</>
					)}

					{managerOptions?.map((pM) => (
						<Dropdown.Item
							key={pM.id}
							text={pM.name}
							onClick={async (e) => {
								e.preventDefault();
								setLoading(true);
								await updateDocument(todo.ref, { userIds: [pM.id], users: [pM] });
								setLoading(false);
							}}
						/>
					))}
				</>
			)}
		</DropdownMenu>
	);
}
